import { useMutation, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import toast from 'react-hot-toast';
import { addComparables } from 'services/apiComparable';

const useAddComparable = () => {
  const queryClient = useQueryClient();

  const{isPending, isSuccess, isError, mutate:addCompOrSub}=useMutation({
    mutationFn: addComparables,
    onSuccess:(data)=>{
        queryClient.setQueryData(['newCompOrSubj'],data)
        toast.success('Added Successfully')
        queryClient.invalidateQueries({queryKey:['compList']})
    },
    onError:(error)=>{
        console.log("Error occurred when creating Org",error)
                if (error?.data && typeof error.data === 'object') {
                // Display all backend validation errors
                for (const key in error.data) {
                    const msg = error.data[key];
                    toast.error(Array.isArray(msg) ? msg[0] : msg);
                }
            } else {
                toast.error(error.message || "Something went wrong.");
            }
    }

  })
  return {isPending,isSuccess,isError,addCompOrSub}
}

export default useAddComparable